<template>
<div id="container" class="elterninfo">
  <div id="elterninfo" class="active">
    <top-menu />
    <top-logo />
    <stoppuhr />
    <lautsprecher />
    <copyright />
    <div class="fullscreen_background active">
      <img src="/static/assets/elterninfo/Hintergrund_2860.jpg" />
    </div>
    <div class="z3 active gigi"><img src="/static/assets/elterninfo/elterninfo_Gigi.png"></div>
    <div class="z5 active dubix"><img src="/static/assets/elterninfo/elterninfo_Dubix.png"></div>
    <div class="z6 active hui"><img src="/static/assets/elterninfo/elterninfo_Hui.png"></div>

    <div class="z14 active text"><img src="/static/assets/elterninfo/elterninfo_headline.png">
      <vuescrollbar tag="div" class="fliesstext active">
        <p>Liebe Eltern,</p>
        <!-- <p>als Mutter und Buchhändlerin freue ich mich über jedes Kind, das die Freude am Lesen entdeckt! </p> -->
        <p>Mit unserem Hugidubies-Stickeralbum nehmen unsere Lesehelden Gigi, Hugi, Dubix und ihr Hund Libero Ihre Kinder mit auf eine spannende Reise voller Abenteuer, Spaß und sympathischer Figuren. Weil kleine Leseratten von fantasievollen Kindergeschichten nie genug bekommen können, haben wir mit der Hugidubies-Kinderwebsite einen weiteren Ort geschaffen, wo sie in die wunderbare Lesewelt, in kostenlose Kindergeschichten zum Vorlesen oder Selberlesen, eintauchen können.</p>
        <p>Kinder wachsen heute ganz selbstverständlich mit verschiedenen medialen Angeboten auf und bewegen sich spielend leicht in der digitalen Welt. Auf der Hugidubies-Website können sie deshalb nicht nur die kostenlosen Kindergeschichten der Hugidubies selbst entdecken, sondern Ausmalbilder zum Ausdrucken kreativ ausgestalten und weitererzählen. Auch Kinderspiele ab 3 Jahren stellen wir Ihren Kleinen online und kostenlos zur Verfügung.</p>
        <p>Da uns ein verantwortungsvoller Umgang mit digitalen Medien wichtig ist, hier noch ein Tipp für Sie: Legen Sie mit Ihrem Kind von Anfang an die Verweildauer auf unserer Hugidubies-Website fest. Für diesen Zweck haben wir eigens einen „Libero-Alarm“ eingerichtet. Geben Sie mit Ihrem Kind gemeinsam die Verweildauer ein und Libero wird Ihrem Kind deren Ende durch unmissverständliches Bellen deutlich machen.</p>
        <p>Herzlich</p>
        <p><img src="/static/assets/elterninfo/unterschrift.jpg"></p>
        <p>Ihre Nina Hugendubel</p>
      </vuescrollbar>
    </div>
  </div>
</div>
</template>

<script>
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Lautsprecher from '@/components/Lautsprecher.vue'
import Copyright from '@/components/Copyright.vue'
import VueScrollBar from 'vue-perfect-scrollbar'

window.$ = window.jQuery = require('jquery')

export default {
  name: 'Elterninfo',
  data () {
    return {
      who: 'Elterninfo'
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright,
    'vuescrollbar': VueScrollBar
  },
  mounted () {
    this.$ga.page(this.$router)
  },
  beforeDestroy () {
    try {
      window.currentAudioX.pause()
    } catch (e) {}
    try {
      window.currentAudio.pause()
    } catch (e) {}
    try {
      window.hintergrundSound.pause()
    } catch (e) {}
  }  
}
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
}

/* Z-Index - Level */

.z1 {
  z-index: 10;
}

.z2 {
  z-index: 20;
}

.z3 {
  z-index: 30;
}

.z4 {
  z-index: 40;
}

.z5 {
  z-index: 50;
}

.z6 {
  z-index: 60;
}

.z7 {
  z-index: 70;
}

.z8 {
  z-index: 80;
}

.z9 {
  z-index: 90;
}

.z10 {
  z-index: 100;
}

.z11 {
  z-index: 110;
}

.z12 {
  z-index: 120;
}

.z13 {
  z-index: 130;
}

.z14 {
  z-index: 140;
}

.z15 {
  z-index: 150;
}

.z16 {
  z-index: 160;
}

.z17 {
  z-index: 170;
}

.z18 {
  z-index: 180;
}

.z19 {
  z-index: 190;
}

.z20 {
  z-index: 200;
}

.z21 {
  z-index: 210;
}

.z22 {
  z-index: 220;
}

.z23 {
  z-index: 230;
}

.z24 {
  z-index: 240;
}

.z25 {
  z-index: 250;
}

.z26 {
  z-index: 260;
}

.z27 {
  z-index: 270;
}

.z28 {
  z-index: 280;
}

.z29 {
  z-index: 290;
}

.z30 {
  z-index: 300;
}

.z31 {
  z-index: 310;
}

.z32 {
  z-index: 320;
}

.z33 {
  z-index: 330;
}

.z34 {
  z-index: 340;
}

.z35 {
  z-index: 350;
}

.z36 {
  z-index: 360;
}

.z37 {
  z-index: 370;
}

.z38 {
  z-index: 380;
}

.z39 {
  z-index: 390;
}

.z40 {
  z-index: 400;
}

.z41 {
  z-index: 410;
}

.z42 {
  z-index: 420;
}

.z43 {
  z-index: 430;
}

.z44 {
  z-index: 440;
}

.z45 {
  z-index: 450;
}

.z46 {
  z-index: 460;
}

.z47 {
  z-index: 470;
}

.z48 {
  z-index: 480;
}

.z49 {
  z-index: 490;
}

.z50 {
  z-index: 500;
}

/* ELTERNINFO */

.z6.active.libero {
  bottom: -4px;
  left: 25%;
}

.z3.active.timer {
  top: 17%;
  right: 24.5%;
}

.libero_alarm .text {
  top: 28%;
  left: 16.5%;
}

.z3.active.minuten {
  top: 65%;
  right: 44%;
}

.z3.active.minuten_02 {
  margin-top: 75px;
}

.z5.active.aus {
  bottom: 10%;
  right: 37%;
}

.z5.active.ok {
  bottom: 10%;
  right: 30%;
}

.libero_alarm #menulayer {
  top: 3.5%;
  right: 22%;
}

.libero_alarm .logoshine {
  top: 0%;
  left: 15%;
}

.libero_alarm .logo {
  top: 3%;
  left: 14%;
}

.libero_alarm div {
  position: absolute;
}

.libero_alarm div {
  display: none;
}

.libero_alarm .active {
  display: block !important;
}

.libero_alarm #libero_alarm {
  position: absolute;
  width: 1920px;
  height: 1080px;
}

/* LIEBRO ALARM */

.elterninfo .gigi {
  bottom: 1.5%;
  left: 29%;
}

.elterninfo .gigi {
  animation: gigi_erscheint 0.5s ease-out;
  animation-delay: 0.5s;
  animation-fill-mode: forwards;
  opacity: 0;
  transform-origin: bottom center;
}

@keyframes gigi_erscheint {
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.elterninfo .dubix {
  bottom: 4%;
  left: 13%;
}

.elterninfo .dubix {
  animation: dubix_erscheint 0.5s ease-out;
  animation-delay: 0.25s;
  animation-fill-mode: forwards;
  opacity: 0;
  transform-origin: bottom center;
  margin-left: -270px;
}

@keyframes dubix_erscheint {
  50% {
    margin-left: -270px;
    opacity: 0;
  }
  100% {
    margin-left: 0px;
    opacity: 1;
  }
}

.elterninfo .hui {
  bottom: 2%;
  right: 12.5%;
}

.elterninfo .hui img {
  animation: hui_erscheint 0.5s ease-out;
  animation-delay: 0.75s;
  animation-fill-mode: forwards;
  opacity: 0;
  transform-origin: bottom center;
  margin-right: -270px;
}

@keyframes hui_erscheint {
  50% {
    margin-right: -270px;
    opacity: 0;
  }
  100% {
    margin-right: 0px;
    opacity: 1;
  }
}

.elterninfo .text {
  top: 26%;
  left: 52%;
}

/*.elterninfo #menulayer {
    top: 3.5%;
    right: 22%;
}
*/

.elterninfo div {
  position: absolute;
}

.elterninfo div {
  display: none;
}

.elterninfo .active {
  display: block !important;
}

.elterninfo #elterninfo {
  position: absolute;
  width: 1920px;
  height: 1080px;
}

.logo,
.menu {
  display: inherit !important;
}

.fliesstext {
  bottom: -386px;
  left: -83.5%;
  width: 694px;
  font-size: 16pt;
  font-family: 'Open Sans';
  font-weight: 400;
  position: absolute;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 360px;
  padding-right: 20px;
}

::-webkit-scrollbar {
  width: 15px;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 0px #cec8c8;
  -webkit-border-radius: 0;
  box-shadow: inset 0 0 0px #cec8c8;
  border-radius: 0;
}

::-webkit-scrollbar-thumb {
  -webkit-border-radius: 10px;
  border-radius: 10px;
  background: #cec8c8;
}

::-webkit-scrollbar-thumb:window-inactive {
  background: #cec8c8;
}

::-webkit-scrollbar-button {
  background: none;
}

::-webkit-scrollbar-button:start:decrement,
::-webkit-scrollbar-button:end:increment {
  height: 20px;
  width: 20px;
  display: none;
  background-repeat: no-repeat;
}
</style>


// WEBPACK FOOTER //
// src/components/Elterninfo.vue